/* eslint-disable no-restricted-globals */
export {}

let intervalId: ReturnType<typeof setInterval> | null = null
export const currentInterval = 120000 // check every 2 minutes
const broadcast = new BroadcastChannel('auth-sync')

// ***
// CHECK TOKEN EXPIRATION AT INTERVALS
// ***

function throttleCheckTokenExpiration() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
  intervalId = setInterval(() => {
    self.postMessage({ type: 'checkTokenExpiration' })
  }, currentInterval)
}

// ***
// HANDLE USER SESSION LOGOUT
// ***

function handleUserSessionLogout() {
  self.postMessage({ type: 'userSessionLogout' })

  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }

  // Broadcast to other tabs
  broadcast.postMessage({ type: 'userSessionLogout' })
}

// ***
// HANDLE INCOMING MESSAGE (FROM CLIENT OR BROADCAST)
// ***

function handleMessage(data: unknown) {
  const { type } = data as { type: string }

  if (type === 'startTokenExpirationCheck') {
    throttleCheckTokenExpiration()
  }

  if (type === 'userSessionLogout') {
    handleUserSessionLogout()
  }
}

// ***
// EVENTS
// ***

// Messages from the tab that uses this worker
self.addEventListener('message', (event: MessageEvent) => {
  handleMessage(event.data)
})

// Messages from other tabs through the broadcast channel
broadcast.addEventListener('message', (event: MessageEvent) => {
  handleMessage(event.data)
})
